import { Button, Panel } from '@/components/Bicester';
import Image from '@/components/Bicester/Image';
import React from 'react';

const QrCode = ({
  qrCodeUrls,
  onClick,
}: {
  qrCodeUrls: { sh_wechat_url: string; bingding_url: string };
  onClick: () => void;
}) => {
  return (
    <div className="site-qrcode-container bg-white z-[1]">
      <Panel className="flex justify-center" withBorderTop={false}>
        <div className="text-[20px] font-[700]">绑定微信获取二次验证验证码</div>
        <div className="mt-[10px]">
          为了登录安全，我们需要进行用户的二次验证，完成一下步骤，验证码会发送到您的微信上海公众号的对话框中！
        </div>
        <div className="flex justify-center my-[50px]">
          <div className="flex flex-col items-center mr-[200px]">
            <Image className="w-[200px] h-[200px]" src={qrCodeUrls.sh_wechat_url} />
            <div className="mt-[10px]">第一步：手机微信扫码关注上海公众号</div>
          </div>
          <div className="flex flex-col items-center">
            <Image
              className="w-[200px] h-[200px]"
              withPublicPath={false}
              src={qrCodeUrls.bingding_url}
            />
            <div className="mt-[10px]">第二步：扫码授权公众号获取微信信息</div>
          </div>
        </div>
        <div className="flex flex-col items-center">
          <div>第三步：授权成功后验证账号绑定状态</div>
          <Button className="w-[220px] bg-[#ddc887] mt-[10px]" onClick={onClick}>
            立即验证
          </Button>
        </div>
      </Panel>
    </div>
  );
};

export default QrCode;
